"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const Bold_1 = __importDefault(require("../TextFormatButton/Bold/Bold"));
const BulletList_1 = __importDefault(require("../TextFormatButton/BulletList/BulletList"));
const Color_1 = __importDefault(require("../TextFormatButton/Color/Color"));
const Heading_1 = __importDefault(require("../TextFormatButton/Heading/Heading"));
const Italic_1 = __importDefault(require("../TextFormatButton/Italic/Italic"));
const NumberList_1 = __importDefault(require("../TextFormatButton/NumberList/NumberList"));
const Paragraph_1 = __importDefault(require("../TextFormatButton/Paragraph/Paragraph"));
const SubHeading_1 = __importDefault(require("../TextFormatButton/SubHeading/SubHeading"));
const Underline_1 = __importDefault(require("../TextFormatButton/Underline/Underline"));
const ui_1 = require("@completeanatomy/ui");
function TextFormattingPanel() {
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'TextFormattingPanel_Container', children: [(0, jsx_runtime_1.jsxs)(Section, { "data-e2e": 'TextFormattingPanel_Section', children: [(0, jsx_runtime_1.jsx)(Heading_1.default, { "data-e2e": 'TextFormattingPanel_HeadingFormatButton' }), (0, jsx_runtime_1.jsx)(SubHeading_1.default, { "data-e2e": 'TextFormattingPanel_SubHeadingFormatButton' }), (0, jsx_runtime_1.jsx)(Paragraph_1.default, { "data-e2e": 'TextFormattingPanel_ParagraphFormatButton' })] }), (0, jsx_runtime_1.jsxs)(Section, { "data-e2e": 'TextFormattingPanel_Section', children: [(0, jsx_runtime_1.jsx)(Color_1.default, { color: ui_1.colorPalette.lust, "data-e2e": 'TextFormattingPanel_ColorFormatButton' }), (0, jsx_runtime_1.jsx)(Color_1.default, { color: ui_1.colorPalette.mexicanPink, "data-e2e": 'TextFormattingPanel_ColorFormatButton' }), (0, jsx_runtime_1.jsx)(Color_1.default, { color: ui_1.colorPalette.ryzaDust, "data-e2e": 'TextFormattingPanel_ColorFormatButton' }), (0, jsx_runtime_1.jsx)(Color_1.default, { color: ui_1.colorPalette.greenBlue, "data-e2e": 'TextFormattingPanel_ColorFormatButton' }), (0, jsx_runtime_1.jsx)(Color_1.default, { color: ui_1.colorPalette.vanadylBlue, "data-e2e": 'TextFormattingPanel_ColorFormatButton' }), (0, jsx_runtime_1.jsx)(Color_1.default, { color: theme.text, strokeColor: theme.gray, "data-e2e": 'TextFormattingPanel_ColorFormatButton' })] }), (0, jsx_runtime_1.jsxs)(Section, { "data-e2e": 'TextFormattingPanel_Section', children: [(0, jsx_runtime_1.jsx)(Bold_1.default, { "data-e2e": 'TextFormattingPanel_BoldFormatButton' }), (0, jsx_runtime_1.jsx)(Italic_1.default, { "data-e2e": 'TextFormattingPanel_ItalicFormatButton' }), (0, jsx_runtime_1.jsx)(Underline_1.default, { "data-e2e": 'TextFormattingPanel_UnderlineFormatButton' })] }), (0, jsx_runtime_1.jsxs)(Section, { "data-e2e": 'TextFormattingPanel_Section', children: [(0, jsx_runtime_1.jsx)(NumberList_1.default, { "data-e2e": 'TextFormattingPanel_NumberListFormatButton' }), (0, jsx_runtime_1.jsx)(BulletList_1.default, { "data-e2e": 'TextFormattingPanel_BulletListFormatButton' })] })] }));
}
exports.default = TextFormattingPanel;
const Section = styled_components_1.default.div `
  display: flex;

  margin-right: 25px;
  padding-right: 25px;
`;
const Container = styled_components_1.default.div `
  display: flex;
  height: ${({ theme }) => theme.headerHeight}px;
  & > ${Section}:not(:last-child) {
    border-right: 1px solid ${props => props.theme.white_50};
  }
`;
